<template>
  <span class="switch" :class="{ disabled: disabled }">
    <input type="checkbox" role="switch" :checked="modelValue" @change="onChange" :disabled="disabled" />
    <span class="slider round"></span>
  </span>
</template>

<script setup lang="ts">
// TODO: legacy component, should be replaced with t-switch
defineProps<{
  modelValue: boolean;
  disabled?: boolean;
}>();
const emit = defineEmits(['update:modelValue']);

function onChange(event: Event) {
  emit('update:modelValue', (event.target as HTMLInputElement).checked);
}
</script>

<style scoped lang="scss">
.switch {
  position: relative;
  display: inline-block;
  width: 2.75rem;
  height: 1.625rem;
}

/* Hide default HTML checkbox */
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: var(--t-color-neutral-300);
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  content: '';
  position: absolute;
  left: 0.125rem;
  bottom: 0.11rem;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
  width: 1.4rem;
  height: 1.4rem;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.2);
}

input:checked + .slider {
  background-color: var(--t-color-neutral-800);
}

input:focus + .slider {
  box-shadow: 0 0 0.0063rem #2196f3;
}

input:checked + .slider:before {
  $slide-distance: 1.1rem;

  -webkit-transform: translateX($slide-distance);
  -ms-transform: translateX($slide-distance);
  transform: translateX($slide-distance);
}

/* Rounded sliders */
.slider.round {
  border-radius: 2.125rem;
  width: 2.75rem;
  height: 1.625rem;
}

.slider.round:before {
  border-radius: var(--t-border-radius-full-rounded);
}

input:disabled + .slider {
  cursor: not-allowed;
}

.disabled {
  cursor: not-allowed;
}
</style>
